import Chip from "@mui/material/Chip";
import { Priority } from "../domain/request.types";

/** Matches the Haystack Bug Tracker's --color-priority-* tokens exactly (light-mode values). */
const PRIORITY_COLORS: Record<Priority, { bg: string; fg: string }> = {
  [Priority.Critical]: { bg: "#dc2626", fg: "#ffffff" },
  [Priority.High]: { bg: "#ea580c", fg: "#ffffff" },
  [Priority.Medium]: { bg: "#ca8a04", fg: "#ffffff" },
  [Priority.Low]: { bg: "#0284c7", fg: "#ffffff" },
};

export interface PriorityChipProps {
  priority: Priority | null;
  size?: "small" | "medium";
}

/** One fixed color mapping, reused everywhere priority is shown (list, kanban-style cards, wizard tiles, detail page).
 * `priority` is null until the Validation Manager sets it on accept - rendered as a neutral "Not set" chip. */
export function PriorityChip({ priority, size = "small" }: PriorityChipProps) {
  if (priority === null) {
    return (
      <Chip
        label="Not set"
        size={size}
        variant="outlined"
        sx={{ color: "text.secondary", fontWeight: 600 }}
      />
    );
  }
  const colors = PRIORITY_COLORS[priority];
  return (
    <Chip
      label={priority}
      size={size}
      sx={{ bgcolor: colors.bg, color: colors.fg, fontWeight: 600 }}
    />
  );
}

export { PRIORITY_COLORS };
